var _circle, _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvatarDarkMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 37.5,
    r: 37.5,
    fill: "#1C1C1C"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 14,
    width: 26,
    height: 26,
    rx: 13,
    fill: "#7A999E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59 66.3636C53.2317 70.7273 49.3741 74 37.5 74C25.6259 74 22.2927 71.2727 16 66.3636C16 57.9287 25.6259 44 37.5 44C49.3741 44 59 57.9287 59 66.3636Z",
    fill: "#7A999E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarDarkMobile);
export default __webpack_public_path__ + "static/media/avatarDarkMobile.25a7aa2011adac476c5231370813f279.svg";
export { ForwardRef as ReactComponent };